import { OrderAdditionalServiceGdsServiceServiceType } from '@websky/graphql';
import { getIsBaggagePet } from '@shared/lib/gdsService';
export function getOrderServiceType(service) {
    switch (service.type) {
        case OrderAdditionalServiceGdsServiceServiceType.Baggage:
            const baggageService = service;
            if (getIsBaggagePet(baggageService.baggageType)) {
                return 'BaggagePet';
            }
            return service.type;
        case OrderAdditionalServiceGdsServiceServiceType.Vip:
            const vipService = service;
            return vipService.subType;
        default:
            return service.type;
    }
}
